import { Injectable, inject } from '@angular/core';
import { GlobalPermissions, LocalPermissions } from 'src/models/global-enum';
import { GeneralStore } from 'src/store/general.store';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  private readonly generalStore = inject(GeneralStore);

  checkRoutePermissions(
    atLeastOneGlobalPermissions?: number[],
    locationId?: number,
    atLeastOneLocalPermissions?: number[],
    checkTaskboardPermissions = false,
  ): boolean {
    let permissableLocation = false;
    if (checkTaskboardPermissions) {
      if (!this.generalStore.isTaskBoardUser()) {
        return false;
      }
    }
    if (locationId) {
      const foundLocation = this.generalStore
        .assignedLocations()
        .find(location => location.id === locationId);
      if (foundLocation) {
        if (atLeastOneLocalPermissions && atLeastOneLocalPermissions.length) {
          if (this.generalStore.isGlobalAdmin() || this.generalStore.isGlobalViewer()) {
            permissableLocation = true;
          } else {
            const locationPermissions = this.generalStore.locationCreds().get(foundLocation.id);
            if (locationPermissions) {
              permissableLocation = false;
              atLeastOneLocalPermissions.forEach((neededPermission: number) => {
                if (locationPermissions.includes(neededPermission)) {
                  permissableLocation = true;
                }
              });
            } else {
              permissableLocation = false;
            }
          }
        } else {
          permissableLocation = true;
        }
      } else {
        return false;
      }
    } else {
      permissableLocation = true;
    }

    let hasPermission = false;
    if (!atLeastOneGlobalPermissions?.length) {
      hasPermission = true;
    } else {
      const foundPermissions: number[] = atLeastOneGlobalPermissions.filter(neededPermission =>
        this.generalStore
          .globalCreds()
          .some((currentPermission: number) => neededPermission === currentPermission),
      );
      hasPermission = foundPermissions && !!foundPermissions.length;
    }

    return (
      (atLeastOneGlobalPermissions?.length && permissableLocation) ||
      (permissableLocation && hasPermission)
    );
  }

  checkViewOnly(locationId: number) {
    const locationCreds = this.generalStore.locationCreds().get(locationId);
    if (this.generalStore.globalCreds().indexOf(GlobalPermissions.GLOBAL_ADMIN) >= 0) {
      return false;
    } else if (
      this.generalStore.locationCreds().get(locationId)?.indexOf(LocalPermissions.LOCAL_ADMIN) ??
      -1 >= 0
    ) {
      return false;
    } else if (this.generalStore.globalCreds().indexOf(GlobalPermissions.GLOBAL_VIEWER) >= 0) {
      return true;
    } else if (!locationCreds) {
      return false;
    } else {
      return locationCreds.includes(LocalPermissions.LOCAL_VIEWER);
    }
  }
}
